import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { secondsToHoursMinutes } from "../utils/timeConverter";

interface Props {
  duration: number; // in seconds
}

// custom hook to reuse duration's format message as an intl variable
export const useDurationFormatMessage = (duration?: number) => {
  const intl = useIntl();

  if (duration) {
    // Convert duration in seconds to hours and minutes
    const { hours, minutes } = secondsToHoursMinutes(duration);

    return intl.formatMessage(
      {
        id: "duration.duration_in_hours_minutes",
        defaultMessage:
          "{hours, plural, =0 {} one {# hr} other {# hours}} {minutes, plural, =0 {} one {# min} other {# mins}}",
      },
      { hours, minutes }
    );
  } else {
    return null;
  }
};

// React component for Duration
const Duration: React.FC<Props> = (props) => {
  // Convert duration in seconds to hours and minutes
  const { hours, minutes } = secondsToHoursMinutes(props.duration);

  return props.duration ? (
    <FormattedMessage
      id="duration.duration_in_hours_minutes"
      defaultMessage="{hours, plural, =0 {} one {# hr} other {# hours}} {minutes, plural, =0 {} one {# min} other {# mins}}"
      values={{ hours, minutes }}
    />
  ) : (
    // Show only 0 if duration === 0
    <>0</>
  );
};

export default Duration;
